import {action, makeAutoObservable, observable, runInAction} from "mobx";
import {inject, injectable} from "inversify";
import type {IPredictionApiProvider} from "data/providers/api/prediction.api.provider";
import {Bindings} from "data/constants/bindings";

export interface IShareStore {
	get shareImagePath(): string;

	sharePredictionImage(): Promise<void>;
}

@injectable()
export class ShareStore implements IShareStore {
	@observable private _shareImagePath: string = "";

	get shareImagePath() {
		return this._shareImagePath;
	}

	constructor(
		@inject(Bindings.PredictionApiProvider) private _predictionApi: IPredictionApiProvider
	) {
		makeAutoObservable(this);
	}

	@action
	async sharePredictionImage() {
		try {
			const response = await this._predictionApi.get_prediction_image();
			const {fileName} = response.data.success;

			runInAction(() => {
				this._shareImagePath = fileName;
			});
		} catch (err) {
			console.log(err);
		}
	}
}
